import {
  useCreateImporterMutation,
  useLazyGetImportGeneralByIdQuery,
  useUpdateImporterMutation,
} from "./ImportPage/CreateNewJob/General/GeneralApiSlice";
import { useCreateHighSeaSellerMutation } from "./ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";

import {
  useCreateProductFTAMutation,
  useLazyGetProductFTAByIdQuery,
} from "./ImportPage/CreateNewJob/Product/ProductFTA/ProductFTAApiSlice";
import {
  useCreateImportAdditionalInfoMutation,
  useDeleteImportAdditionalInfoMutation,
  useUpdateImportAdditionalInfoMutation,
  useLazyGetImportAdditionalInfoByIdQuery,
} from "./ImportPage/CreateNewJob/Product/SingleWindow/AdditionalInfoApi";
import {
  useCreateImportConstituentMutation,
  useDeleteImportConstituentMutation,
  useUpdateImportConstituentMutation,
  useLazyGetImportConstituentsByIdQuery,
} from "./ImportPage/CreateNewJob/Product/SingleWindow/ConstituentsApi";
import {
  useCreateImportProductionDetailMutation,
  useDeleteImportProductionDetailMutation,
  useUpdateImportProductionDetailMutation,
  useLazyGetImportProductionDetailsByIdQuery,
} from "./ImportPage/CreateNewJob/Product/SingleWindow/ProductionDetailsApi";
import {
  useCreateImportControlDetailMutation,
  useDeleteImportControlDetailMutation,
  useLazyGetImportControlDetailsByIdQuery,
  useUpdateImportControlDetailMutation,
} from "./ImportPage/CreateNewJob/Product/SingleWindow/ControlDetailsApi";
import {
  useCreateProductLoadingMutation,
  useUpdateProductLoadingMutation,
  useLazyGetProductLoadIdQuery,
} from "./ImportPage/CreateNewJob/Product/Loading/LoadingSlice";

import {
  useLazyGetImportSezInfoByIdQuery,
  useCreateImportSezInfoMutation,
} from "./ImportPage/CreateNewJob/SezInfo/SezInfoApiSlice";
import {
  useLazyGetShipmentByIdQuery,
  useUpdateShipmentMutation,
  useDeleteShipmentMutation,
  useCreateShipmentMutation,
} from "./ImportPage/CreateNewJob/Shipment/ShipmentApiSlice";
import {
  useCreateProductMainMutation,
  useLazyGetProductInvoiceMainIdQuery,
  useUpdateProductMainMutation,
  useDeleteProductMainMutation,
} from "./ImportPage/CreateNewJob/Product/ProductMain/MainSlice";
import {
  useCreateSchemeGenericMutation,
  useUpdateSchemeGenericMutation,
  useLazyGetSchemeByIdQuery,
} from "./ImportPage/CreateNewJob/Product/General/SchemeandGenericDes/SchemeGeneric";
import {
  useCreateManufactureMutation,
  useUpdateManufactureMutation,
  useLazyGetManufactureIdQuery,
} from "./ImportPage/CreateNewJob/Product/General/Manufacuter/Manufacuter";

import {
  useCreateLICSchemeMutation,
  useUpdateLICSchemeMutation,
  useLazyGetLICSchemeIdQuery,
} from "./ImportPage/CreateNewJob/Product/LIC/LICSCheme/LicScheme";

import {
  useCreateEOUDetailsMutation,
  useUpdateEOUDetailsMutation,
  useLazyGetEOUDetailsIdQuery,
  useCreateEOUDetailsItemMutation,
  useLazyGetEOCItemIdQuery,
  useUpdateEOUDetailsItemMutation,
  useDeleteEOUDetailsItemMutation,
} from "./ImportPage/CreateNewJob/Product/LIC/EOU Details/EOUDetails";
import {
  useGetimportDashboardQuery,
  useToggleimportLockMutation,
  useDeleteImportJobMutation,
} from "@/redux/ImportPage/Dashboard/DashboardSlice";
import {
  useLazyGetInvoiceImportByMasterIdQuery,
  useCreateImportInvoiceMutation,
  useUpdateImportInvoiceMutation,
  useDeleteImportInvoiceMutation,
} from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceMainSlice.js";
import { useApplyimportDashboardFilterMutation } from "@/redux/ImportPage/Dashboard/DashboardfilterSlice";
import {
  useCreateInvoiceSupplierMutation,
  useLazyGetInvoiceSupplierByIdQuery,
} from "./ImportPage/CreateNewJob/Invoice/InvoiceSupplierSlice";
import { useLazyGetHistoryQuery } from "./ImportPage/CreateNewJob/History/HistorySlice";

import {
  useCreateEntityMutation,
  useUpdateEntityMutation,
  useDeleteEntityMutation,
  useLazyGetEntityIdQuery,
} from "./ImportPage/CreateNewJob/Entity/EntitySlice";
import {
  useCreateESanchitMutation,
  useLazyGetEsanchitIdQuery,
  useUpdateESanchitMutation,
  useDeleteESanchitMutation,
  useLazyGetFilterESanchitImportQuery,
} from "./ImportPage/CreateNewJob/Esanchit/Esanchit";
import {
  useCreateImportProductSezMutation,
  useLazyGetSezInfoIdQuery,
  useUpdateProductSezMutation,
  useDeleteProductSezMutation,
} from "./ImportPage/CreateNewJob/Product/General/Sezinfo/Sezinfo";

import {
  useLazyGetSvbDetailsByIdQuery,
  useUpdateSvbDetailsMutation,
} from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceRevSlice.js";
import {
  useLazyGetInvoiceOtherDetailsByIdQuery,
  useUpdateInvoiceOtherDetailsMutation,
} from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceOtherInfoSlice.js";
import {
  useLazyGetOtherDetailsByIdQuery,
  useCreateOtherDetailMutation,
} from "@/redux/ImportPage/CreateNewJob/Product/Otherdetails/OtherdetailSlice.js";
import {
  useLazyGetExchangeRateByIdQuery,
  useUpdateExchangeRateMutation,
} from "@/redux/ImportPage/CreateNewJob/ExchangeRate/ExchangeRate.js";
import {
  useLazyGetRequirementByMasterIdQuery,
  useCreateRequirementMutation,
  useUpdateRequirementMutation,
  useDeleteRequirementMutation,
} from "@/redux/ImportPage/CreateNewJob/Requirement/RequirementSlice.js";
import {
  useLazyGetUdfByMasterIdQuery,
  useCreateUdfMutation,
} from "@/redux/ImportPage/CreateNewJob/UDF/UDFSlice.js";

import {
  useCreateImportNotesMutation,
  useUpdateImportNotesMutation,
  useLazyGetNotesByImporterIdQuery,
  useDeleteImportNoteMutation,
  useFileUploadMutation,
} from "@/redux/ImportPage/CreateNewJob/Notes/NoteSlice.js";

import {
  useGetContainerByMasterIdQuery,
  useGetContainerByIdQuery,
} from "@/redux/ImportPage/CreateNewJob/Shipment/ContainerSlice.js";

import {
  useCreateBondcertMutation,
  useUpdateBondcertMutation,
  useDeleteBondcertMutation,
  useLazyGetBondCertIdQuery,
} from "./ImportPage/CreateNewJob/BondCert/BondCert";
import {
  useCreateReimportMutation,
  useLazyGetReimportByIdQuery,
  useUpdateReimportMutation,
  useDeleteReimportMutation,
} from "./ImportPage/CreateNewJob/Product/Reimport/ReImportSilce";

import {
  useGetInvoiceOtherChargesByMasterIdQuery,
  useLazyGetInvoiceOtherChargesByIdQuery,
  useUpdateInvoiceOtherChargesMutation,
} from "../redux/ImportPage/CreateNewJob/Invoice/InvoiceOtherCharges.js";
import {
  useCreateProductCustDutyMutation,
  useUpdateProductCustDutyMutation,
  useLazyGetProductCustDutyIdQuery,
} from "../redux/ImportPage/CreateNewJob/Product/CustDuty/Custduty.js";
import {
  useCreateProductGSTMutation,
  useUpdateProductGSTMutation,
  useLazyGetProductGSTIdQuery,
} from "../redux/ImportPage/CreateNewJob/Product/GST/GST.js";
import {  useCreateProductOtherDutiesMutation,
  useUpdateProductOtherDutiesMutation,
  useLazyGetProductOtherDutiesIdQuery,} from "../redux/ImportPage/CreateNewJob/Product/OtherDuties/OtherDuties.js"  


export const importHookMap = {
  importer: (id) => {
    const [create, createState] = useCreateImporterMutation();
    const [update, updateState] = useUpdateImporterMutation();
    const [fetchImportGeneral, { data, isLoading }] =
      useLazyGetImportGeneralByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch importer data");
      return await fetchImportGeneral({ id }).unwrap();
    };

    return { create, createState, update, updateState, fetch, data, isLoading };
  },

  importentity: (id) => {
    const [create, createState] = useCreateEntityMutation();
    const [update, updateState] = useUpdateEntityMutation();
    const [deleteFn, deleteState] = useDeleteEntityMutation();
    const [fetchEntityId, { data, isLoading }] = useLazyGetEntityIdQuery(id);
    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchEntityId({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  importSez: (id) => {
    const [create, createState] = useCreateImportSezInfoMutation();
    const [fetchImportSez, { data, isLoading }] =
      useLazyGetImportSezInfoByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch SEZ info");
      return await fetchImportSez({ id }).unwrap();
    };

    return { create, createState, fetch, data, isLoading };
  },

  invoiceMain: (id) => {
    const [create, createState] = useCreateImportInvoiceMutation();
    const [update, updateState] = useUpdateImportInvoiceMutation();
    const [deleteFn, deleteState] = useDeleteImportInvoiceMutation();
    const [fetchInvoiceById, { data, isLoading }] =
      useLazyGetInvoiceImportByMasterIdQuery();

    const fetch = async ({ id }) => {
      if (!id) {
        console.warn("fetchInvoiceById called without ID");
        return [];
      }
      return await fetchInvoiceById({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },

  importshipment: (id) => {
    const [create, createState] = useCreateShipmentMutation();
    const [update, updateState] = useUpdateShipmentMutation();
    const [deleteFn, deleteState] = useDeleteShipmentMutation();
    const [fetchImportshipment, { data, isLoading }] =
      useLazyGetShipmentByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("Shipment ID is required");
      return await fetchImportshipment({ id }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },

  importproductMain: (id) => {
    const [create, createState] = useCreateProductMainMutation();
    const [update, updateState] = useUpdateProductMainMutation();
    const [deleteFn, deleteState] = useDeleteProductMainMutation();
    const [fetchImportproductMain, { data, isLoading }] =
      useLazyGetProductInvoiceMainIdQuery();

    const fetch = async ({ id }) => {
      if (!id)
        throw new Error("ProductMain is required to fetch exporter data");
      const response = await fetchImportproductMain({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },

  importinvoiceSvb: (id) => {
    const [update, updateState] = useUpdateSvbDetailsMutation();
    const [create, createState] = useUpdateSvbDetailsMutation();
    const [fetchimportproductMain, { data, isLoading }] =
      useLazyGetSvbDetailsByIdQuery();

    const fetch = async ({ id, subId }) => {
      if (!id || !subId) throw new Error("Shipment ID is required");
      return await fetchimportproductMain({ id, subId }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },

  invoiceOtherDetails: (id) => {
    const [update, updateState] = useUpdateInvoiceOtherDetailsMutation();
    const [create, createState] = useUpdateInvoiceOtherDetailsMutation();
    const [fetchinvoiceOtherDetails, { data, isLoading }] =
      useLazyGetInvoiceOtherDetailsByIdQuery();

    const fetch = async ({ id, subId }) => {
      if (!id || !subId) throw new Error("Shipment ID is required");
      return await fetchinvoiceOtherDetails({ id, subId }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },
  InvoiceOtherCharges: () => {
    const [create, createState] = useUpdateInvoiceOtherChargesMutation();
    const [update, updateState] = useUpdateInvoiceOtherChargesMutation();
    const [fetchinvoiceOtherDetails, { data, isLoading }] =
      useLazyGetInvoiceOtherChargesByIdQuery();
    const fetch = async ({ id, subId }) => {
      if (!id || !subId) throw new Error("Shipment ID is required");
      return await fetchinvoiceOtherDetails({ id, subId }).unwrap();
    };

    return {
      create,
      createState,
      update,
      updateState,
      fetch,
      data,
      isLoading,
    };
  },

  importSchemeGeneric: (id) => {
    const [create, createState] = useCreateSchemeGenericMutation();
    const [update, updateState] = useUpdateSchemeGenericMutation();

    const [fetchImportSchemeGeneric, { data, isLoading }] =
      useLazyGetSchemeByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportSchemeGeneric({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
    };
  },

  importManufacturer: (id) => {
    const [create, createState] = useCreateManufactureMutation();
    const [update, updateState] = useUpdateManufactureMutation();
    const [fetchImportManufacturer, { data, isLoading }] =
      useLazyGetManufactureIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportManufacturer({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
    };
  },

  importLICScheme: (id) => {
    const [create, createState] = useCreateLICSchemeMutation();
    const [update, updateState] = useUpdateLICSchemeMutation();
    const [fetchImportLICScheme, { data, isLoading }] =
      useLazyGetLICSchemeIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportLICScheme({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
    };
  },

  importEOUDetails: (id) => {
    // Hooks MUST be called here at top level
    const [create, createState] = useCreateEOUDetailsMutation();
    const [update, updateState] = useUpdateEOUDetailsMutation();
    const [fetchEOUDetails, { data, isLoading }] =
      useLazyGetEOUDetailsIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchEOUDetails({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
    };
  },
  importProductSezinfo: (id) => {
    // Hooks MUST be called here at top level
    const [create, createState] = useCreateImportProductSezMutation(); // useDeleteProductSezMutation
    const [update, updateState] = useUpdateProductSezMutation();
    const [deleteFn, deleteState] = useDeleteProductSezMutation();

    const [fetchSezinfo, { data, isLoading }] = useLazyGetSezInfoIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Sez is required to fetch exporter data");
      const response = await fetchSezinfo({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },

  importEOUDetailsItem: (id) => {
    // Hooks MUST be called here at top level
    const [create, createState] = useCreateEOUDetailsItemMutation();
    const [update, updateState] = useUpdateEOUDetailsItemMutation(); //useDeleteEOUDetailsItemMutation
    const [deleteTableFn, deleteState] = useDeleteEOUDetailsItemMutation();
    const [fetchEOUDetailsItem, { data, isLoading }] =
      useLazyGetEOCItemIdQuery(); //useLazyGetEOUDetailsIdQuery
    const fetchTable = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchEOUDetailsItem({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetchTable,
      data,
      isLoading,
      update,
      updateState,
      deleteTableFn,
      deleteState,
    };
  },

  importProductFTA: () => {
    const [create, createState] = useCreateProductFTAMutation();
    const [fetchImportProductFTA, { data, isLoading }] =
      useLazyGetProductFTAByIdQuery();
    const fetch = async ({ id = "68f9f3a929531674453c2451" }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportProductFTA({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },

  importAdditionalInfo: () => {
    const [create, createState] = useCreateImportAdditionalInfoMutation();
    const [update, updateState] = useUpdateImportAdditionalInfoMutation();
    const [deleteFn, deleteState] = useDeleteImportAdditionalInfoMutation();
    const [fetchImportAdditionalInfo, { data, isLoading }] =
      useLazyGetImportAdditionalInfoByIdQuery();
    const fetch = async ({ id = "68f9f3a929531674453c2451" }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportAdditionalInfo({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },

  importConstituents: () => {
    const [create, createState] = useCreateImportConstituentMutation();
    const [update, updateState] = useUpdateImportConstituentMutation();
    const [deleteFn, deleteState] = useDeleteImportConstituentMutation();
    const [fetchImportConstituents, { data, isLoading }] =
      useLazyGetImportConstituentsByIdQuery();
    const fetch = async ({ id = "68f9f3a929531674453c2451" }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportConstituents({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },

  importControlDetail: () => {
    const [create, createState] = useCreateImportControlDetailMutation();
    const [update, updateState] = useUpdateImportControlDetailMutation();
    const [deleteFn, deleteState] = useDeleteImportControlDetailMutation();
    const [fetchImportControlDetail, { data, isLoading }] =
      useLazyGetImportControlDetailsByIdQuery();
    const fetch = async ({ id = "68f9f3a929531674453c2451" }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportControlDetail({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },

  importProductionDetail: () => {
    const [create, createState] = useCreateImportProductionDetailMutation();
    const [update, updateState] = useUpdateImportProductionDetailMutation();
    const [deleteFn, deleteState] = useDeleteImportProductionDetailMutation();
    const [fetchImportProductionDetail, { data, isLoading }] =
      useLazyGetImportProductionDetailsByIdQuery();
    const fetch = async ({ id = "68f9f3a929531674453c2451" }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchImportProductionDetail({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      fetch,
      data,
      isLoading,
    };
  },
  invoiceSupplier: () => {
    const [create, createState] = useCreateInvoiceSupplierMutation();
    const [fetchInvoiceSupplier, { data, isLoading }] =
      useLazyGetInvoiceSupplierByIdQuery();
    const fetch = async ({ id, subId }) => {
      if (!id || !subId)
        throw new Error("Schme is required to fetch exporter data");
      const response = await fetchInvoiceSupplier({ id, subId }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },

  esanchit: (id) => {
    // Hooks MUST be called here at top level
    const [create, createState] = useCreateESanchitMutation();
    const [update, updateState] = useUpdateESanchitMutation();
    const [deleteFn, deleteState] = useDeleteESanchitMutation();

    const [fetcheSanchit, { data, isLoading }] = useLazyGetEsanchitIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetcheSanchit({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      update,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },
  //useLazyGetFilterESanchitQuery
  eSanchitFilterImport: () => {
    const [fetchEsanchitFilter, { data, isLoading, error }] =
      useLazyGetFilterESanchitImportQuery();

    const fetch = async ({ id, data }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchEsanchitFilter({ id, data }).unwrap();
      return response;
    };
    return { fetch, data, isLoading, error };
  },

  productOtherInfo: () => {
    const [create, createState] = useCreateOtherDetailMutation();
    const [fetchproductOtherInfo, { data, isLoading }] =
      useLazyGetOtherDetailsByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchproductOtherInfo({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },

  importProductLoading: (id) => {
    // Hooks MUST be called here at top level
    const [create, createState] = useCreateProductLoadingMutation();
    const [update, updateState] = useUpdateProductLoadingMutation();

    const [fetchProductLoad, { data, isLoading }] =
      useLazyGetProductLoadIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("Schme is required to fetch exporter data");
      const response = await fetchProductLoad({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
    };
  },

  //useLazyGetHistoryQuery

  importhistoryApi: (id) => {
    const [fetchHistoryDetails, { data, isLoading }] = useLazyGetHistoryQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = await fetchHistoryDetails({ id }).unwrap();
      return response;
    };

    return { data, isLoading, fetch };
  },

  exchangeRate: (id) => {
    const [create, cretaeState] = useUpdateExchangeRateMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetExchangeRateByIdQuery();

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return { data, isLoading, fetch, create, cretaeState };
  },

  requirement: (id) => {
    const [create, createState] = useCreateRequirementMutation();
    const [update, updateState] = useUpdateRequirementMutation();
    const [deleteFn, deleteState] = useDeleteRequirementMutation();
    const [fetchRequirement, { data, isLoading }] =
      useLazyGetRequirementByMasterIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchRequirement({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  udf: (id) => {
    const [create, createState] = useCreateUdfMutation();
    const [fetchudf, { data, isLoading }] = useLazyGetUdfByMasterIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchudf({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  exportNotes: (id) => {
    const [create, createState] = useCreateImportNotesMutation();
    const [update, updateState] = useUpdateImportNotesMutation();
    const [fecthNotesDetails, { data, isLoading }] =
      useLazyGetNotesByImporterIdQuery(id);
    const [fileUpload, fileUploadState] = useFileUploadMutation();
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = subId
        ? await fecthNotesDetails({ id, subId }).unwrap()
        : await fecthNotesDetails({ id }).unwrap();
      return response;
    };
    const [deleteFn, deleteState] = useDeleteImportNoteMutation();
    return {
      create,
      createState,
      update,
      updateState,
      data,
      isLoading,
      fetch,
      deleteFn,
      deleteState,
      fileUpload,
      fileUploadState,
    };
  },

  bondcert: (id) => {
    const [create, createState] = useCreateBondcertMutation();
    const [update, updateState] = useUpdateBondcertMutation();
    const [deleteFn, deleteState] = useDeleteBondcertMutation();
    const [fetctBondcert, { data, isLoading }] = useLazyGetBondCertIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetctBondcert({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },
  //useCreateReimportMutation

  reimport: (id) => {
    const [create, createState] = useCreateReimportMutation();
    const [update, updateState] = useUpdateReimportMutation();
    const [deleteFn, deleteState] = useDeleteReimportMutation();
    const [fetctReimport, { data, isLoading }] = useLazyGetReimportByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetctReimport({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },
  ProductCustDuty: (id) => {
    const [create, createState] = useCreateProductCustDutyMutation();
    const [update, updateState] = useUpdateProductCustDutyMutation();
    const [deleteFn, deleteState] = useDeleteReimportMutation();
    const [fetctReimport, { data, isLoading }] =
      useLazyGetProductCustDutyIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetctReimport({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  ProductGST: (id) => {
    const [create, createState] = useCreateProductGSTMutation();
    const [update, updateState] = useUpdateProductGSTMutation();
    const [fetctReimport, { data, isLoading }] =
    useLazyGetProductGSTIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetctReimport({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      data,
      isLoading,
      fetch,
    };
  },


  ProductOtherDuties: (id) => {
    const [create, createState] = useCreateProductOtherDutiesMutation();
    const [update, updateState] = useUpdateProductOtherDutiesMutation();
    const [fetctReimport, { data, isLoading }] =
    useLazyGetProductOtherDutiesIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetctReimport({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      data,
      isLoading,
      fetch,
    };
  },

  // Direct hooks (not wrapped in a function)
  getInvoiceMaster: useLazyGetInvoiceImportByMasterIdQuery,
  getimportDashboard: useGetimportDashboardQuery,
  toggleimportLock: useToggleimportLockMutation,
  deleteImportJob: useDeleteImportJobMutation,
  applyimportDashboardFilter: useApplyimportDashboardFilterMutation,
  getPackageDetails: useGetContainerByMasterIdQuery,
  getPackageDetailsById: useGetContainerByIdQuery,
};
